import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-side-dialog-nav',
  standalone: true,
  imports: [],
  template: '<ng-content></ng-content>',
  styleUrls: ['./side-dialog-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideDialogNavComponent {

}
